import React from 'react'
import HealthInformation from './HealthInformation'

export default function LifeAndDisability () {
  return <HealthInformation path='lifeDisability' />
}